import actionConsts from '../../constants/actions';

const user = (state = [], action = {}) => {
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return action.payload.user ? action.payload.user : {};
        default:
            return state;
    }
};

export default user;


// WEBPACK FOOTER //
// /src/reducers/uiState/user.js